import axios from 'axios';
import {clearLocalStorage, saveTokenFromResponse} from "@/helpers";
import {logoutApi} from "@/api/auth";

export const API_BASE_URL = process.env.VUE_APP_API_URL;

export const api = axios.create({
    baseURL: API_BASE_URL,
});

export const affPartnersApi = axios.create({
    baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('crm_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

let isRefreshing = false;
let refreshSubscribers = [];
api.interceptors.response.use(
    (config) => config,
    async (error) => {
        const originalRequest = error.config;

        if (originalRequest?.url === "/auth/login") {
            throw error;
        }

        if (error.response?.status === 401) {
            if (isRefreshing) {
                return new Promise((resolve) => {
                    refreshSubscribers.push((newToken) => {
                        originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
                        resolve(api.request(originalRequest));
                    });
                });
            }

            isRefreshing = true;

            try {
                const response = await refresh();
                const newToken = response.data.token;
                saveTokenFromResponse(response.data);

                refreshSubscribers.forEach((callback) => callback(newToken));
                refreshSubscribers = [];

                return api.request(originalRequest);
            } catch (refreshError) {
                refreshSubscribers = [];
                clearLocalStorage();
                try {
                    await logoutApi()
                } catch (logoutError) {
                    void logoutError;
                }
                window.location.assign('/auth');
                throw error;
            } finally {
                isRefreshing = false;
            }
        }

        throw error;
    }
);

export async function refresh() {
    const response = await axios.create({
        withCredentials: true,
        baseURL: API_BASE_URL,
    }).post('/auth/refresh');
    return response;
}
